// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerRequest {
    padding-bottom: 16px;
}

.titleRequest {
    font-size: 18px;
    font-weight: 700
}
.containerDataApprover {
    display: flex;
    gap: 16px;
    padding-bottom: 24px;
    font-size: 16px;
    flex-wrap: wrap;
}

.dataRow {
    display: flex;
    align-items: end;
    gap: 6px;
}

.dataLabel {
    font-weight: 600;
}

.dataValueWithAction {
    display: flex;
    align-items: center;
    gap: 6px;
}

.iconEdit {
    width: 25px;
    cursor: pointer;
}

.iconEdit:hover {
    background-color: #D1E4FF;
    border: solid 1px #00629A;
}`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/DadosAprovador/dadosAprovador.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf;AACJ;AACA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B","sourcesContent":[".headerRequest {\n    padding-bottom: 16px;\n}\n\n.titleRequest {\n    font-size: 18px;\n    font-weight: 700\n}\n.containerDataApprover {\n    display: flex;\n    gap: 16px;\n    padding-bottom: 24px;\n    font-size: 16px;\n    flex-wrap: wrap;\n}\n\n.dataRow {\n    display: flex;\n    align-items: end;\n    gap: 6px;\n}\n\n.dataLabel {\n    font-weight: 600;\n}\n\n.dataValueWithAction {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.iconEdit {\n    width: 25px;\n    cursor: pointer;\n}\n\n.iconEdit:hover {\n    background-color: #D1E4FF;\n    border: solid 1px #00629A;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
